import { useState, useEffect } from 'react';
import { Search, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const PublicSearchBar = ({ onSearch, placeholder = "Rechercher un poste, une ville, un département..." }) => {
  const [inputValue, setInputValue] = useState('');

  // Debounce logic
  useEffect(() => {
    const timer = setTimeout(() => {
      onSearch(inputValue);
    }, 300);

    return () => clearTimeout(timer);
  }, [inputValue, onSearch]);

  const handleClear = () => {
    setInputValue('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleClear();
    }
  };

  return (
    <div className="relative w-full max-w-2xl mx-auto group">
      {/* Subtle glow effect behind the search bar */}
      <div className="absolute -inset-0.5 bg-gradient-to-r from-lenvia-blue/20 to-lenvia-violet/20 rounded-xl blur opacity-30 group-hover:opacity-60 transition duration-500"></div>
      
      <div className="relative flex items-center w-full bg-white/5 border border-white/10 rounded-xl overflow-hidden glass transition-all duration-300 focus-within:border-lenvia-blue/50 focus-within:bg-white/10 focus-within:shadow-[0_0_15px_rgba(37,99,235,0.15)]">
        <div className="pl-4 pr-3 py-3 text-slate-400 group-focus-within:text-lenvia-blue transition-colors">
          <Search className="w-5 h-5" />
        </div>
        
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          aria-label="Rechercher des offres d'emploi"
          className="w-full bg-transparent border-none text-white placeholder:text-slate-500 py-3 pr-4 focus:outline-none focus:ring-0 text-base"
        />

        <AnimatePresence>
          {inputValue && (
            <motion.button
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.15 }}
              onClick={handleClear}
              className="p-3 mr-1 text-slate-400 hover:text-white transition-colors flex-shrink-0"
              aria-label="Effacer la recherche"
            >
              <X className="w-4 h-4" />
            </motion.button>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default PublicSearchBar;
